import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';

import useAuth from 'src/hooks/useAuth';
import { canAccessErrorMonitor } from 'src/utils/internalAccess';

const RequireErrorMonitorAccess = ({ children }) => {
  const { user } = useAuth();

  return canAccessErrorMonitor(user)
    ? children
    : <Navigate to="/app/applications/workflow" replace />;
};

RequireErrorMonitorAccess.propTypes = {
  children: PropTypes.node.isRequired
};

export default RequireErrorMonitorAccess;
